import "./newLocalSite.scss";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import { useState } from "react";
import newRequest from "../../../context/newRequest";
import {useNavigate} from "react-router-dom";

const NewLocalSite = ({ inputs, title }) => {
    const [localSite, setlocalSite] = useState({});
    const [StatusSite, setStatusSite] = useState(["ACTIVE"]);
    const [sending, setSending] = useState("");
    const navigate = useNavigate();
    const user = localStorage.getItem("user");


    const handleSelectStatusSite = (e) => {
        const value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
        setStatusSite(value);
    };




    const handleChange = (e) => {
        setlocalSite((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            setSending("On Submit")
            const newlocalSite = {
                ...localSite,
                status_site: StatusSite[0],
            };

            const res= await newRequest.post("/localsite", newlocalSite, {
                // headers
                headers: {
                    'Authorization': `$Bearer ${user.token}`
                },
            } );
            setSending("Mengirim Submit")

            const data = res.data.data
            if (res.status == 200) {
                setSending("Submit berhasil")
                navigate(`/localsite/${data.id}`);
            }
            console.log(res.status)
        } catch (err) {
            setSending(err.response.data.errors)
            console.log(err.response.data.data);
        }
    };
    return (
        <div className="new">
            <Sidebar />
            <div className="newContainer">
                <Navbar/>
                <div className="top">
                    <h1>{title}</h1>
                </div>
                <div className="bottom">
                    <div className="right">
                        <form>
                            <div className="formInput">
                                <label>Site Name</label>
                                <input placeholder="name site" value={localSite.customer_site}
                                       onChange={handleChange} id="name_site"/>
                                <label>POP ID</label>
                                <input placeholder="POP ID" value={localSite.vendor_id} onChange={handleChange}
                                       id="pop_id"/>
                                <label>BANDWITH</label>
                                <input placeholder="bandwith" value={localSite.bandwith} onChange={handleChange}
                                       id="bandwith"/>
                                <label className="label">Status Site ID</label>
                                <select id="status_site" onChange={handleSelectStatusSite}>
                                    <option value="">Pilih Status Site ID</option>
                                    <option value="ACTIVE">ACTIVE</option>
                                    <option value="TERMINATE">TERMINATE</option>
                                </select>


                            </div>
                        </form>
                        <button onClick={handleClick}>Send</button>
                    </div>
                </div>
                {sending && <p className="error">{sending}</p>}
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

            </div>
        </div>
    );
};

export default NewLocalSite;
